module.exports = __webpack_public_path__ + "assets/2bf82011691ff8065e6d61b8ff981066.png";